export default function RequiredAsterisk() {
  return (
    <abbr
      style={{
        borderBottom: "none !important",
        textDecoration: "none !important",
        color: "#df1400",
      }}
      title="(obligatoire)"
    >
      {" "}
      *
    </abbr>
  );
}
